// core
import { Injectable, Inject } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class PortalOneHandoverService {

  constructor(
    @Inject('environment') private environment: any
  ) { }

  // user cannot yet be authorised in portal 2
  // redirectToPortalDashboard() {
  //   // TODO: channel is hardcoded as retailer. This needs to be dynamic in future
  //   window.location.href = [
  //     this.environment.openPortal,
  //     '?partner=huddle&channel=RT&redirect=',
  //     this.environment.frontend,
  //     '/dashboard&jwt=',
  //     Auth.getToken()
  //   ].join('');
  // }

  bookAppointment(type: string, quote?: any, partner?: any) {
    var actionAppointment = '&action=appointment';
    var payload = {
      action: 'appointment',
      type: type ? type.split('-')[1] : null,
      class: quote && quote.product && quote.product.class,
      partner: partner && partner.slug
    };

    // old authentication check, user cannot yet be authorised in portal 2
    // if (Auth.isAuthenticated() && quote && quote.slug) {
    //   window.open([
    //     this.environment.openPortal,
    //     '?partner=huddle',
    //     '&jwt=',
    //     Auth.getToken(),
    //     actionAppointment,
    //     '&redirect=booking/',
    //     type,
    //     quote ? '/' + quote.slug : ''
    //   ].join(''), '_blank');
    // if (quote && quote.slug && quote.product) {
    //   // the "redirect" link is partner link to use, on quote success page
    //   // the "redirectBack" link is default link of partner to go back to
    //   window.open([
    //     this.environment.openPortal,
    //     '?key=',
    //     this.environment.huddlePublicKey,
    //     '&pc=',
    //     quote.product.slug,
    //     '&qr=',
    //     quote.slug,
    //     '&redirect=',
    //     quote.product.slug,
    //     '&redirectBack=',
    //     quote.product.slug,
    //     actionAppointment,
    //     '&payload=',
    //     JSON.stringify(payload)
    //   ].join(''), '_blank');
    // } else {
      window.open(this.environment.openPortal + '/booking/' + type + '?partner=' + (partner && partner.slug), '_blank');
    // }
  }

}
